/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=44269259"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_d85da01a77df37a43522584b1e40a7a6/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__